import { render, staticRenderFns } from "./gridColorSelector.vue?vue&type=template&id=09d0c4b8&scoped=true&"
import script from "./gridColorSelector.vue?vue&type=script&lang=js&"
export * from "./gridColorSelector.vue?vue&type=script&lang=js&"
import style0 from "./gridColorSelector.vue?vue&type=style&index=0&id=09d0c4b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d0c4b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VChip,VColorPicker,VMenu,VSpacer})
